import React from 'react';
import AnswerAvatarCommon from '../../mc-common/answer-avatar';

//right now, 2 component is the same, in the future, we might need to refactor this like mc/answer-text
const AnswerAvatar = AnswerAvatarCommon;

export default AnswerAvatar;
